import { View } from "@src/components";
import { FC, memo } from "react";
import { NumericButton } from "../NumericButton";

type NumericKeyboardProps = {
  onPress: (value: number) => void;
  onDelete: () => void;
  enabled?: boolean;
};

export const NumericKeyboard: FC<NumericKeyboardProps> = memo(({ onPress, onDelete, enabled }) => {
  const buttons = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    ["", 0, "delete"],
  ];

  return (
    <View mt="6xl" p="4xl" alignItems="center">
      {buttons.map((row, rowIndex) => (
        <View key={rowIndex} mb="md" gap="md" flexDirection="row">
          {row.map((button) => (
            <NumericButton key={button} value={button} onPress={onPress} onDelete={onDelete} enabled={enabled} />
          ))}
        </View>
      ))}
    </View>
  );
});
